import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { RouterAuthService } from './router-auth.service';


@Injectable()
export class UserRouteAccessService implements CanActivate {

    constructor(private auth: RouterAuthService) {
    }

    canActivate(route: ActivatedRouteSnapshot): boolean | Promise<boolean> {
        return this.auth.authorize(route);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/user-route-access-service.ts